import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const STORAGE_KEY = 'wp_external_language';

interface LocalizationState {
  /** Current locale (BCP 47 tag). Defaults to en-US. */
  language: string;
  setLanguage: (lang: string) => void;
}

export const useLocalizationStore = create<LocalizationState>()(
  devtools(
    (set) => ({
      language: localStorage.getItem(STORAGE_KEY) ?? 'en-US',

      setLanguage: (lang) => {
        localStorage.setItem(STORAGE_KEY, lang);
        set({ language: lang });
      },
    }),
    { name: 'ds-external-localization-store' },
  ),
);
